const GLOBAL_VARIABLES= window.appticles.config;
export default GLOBAL_VARIABLES;
export const AUTH_INVALID_TOKEN = 'jwt_auth_invalid_token';
export const SERVICE_LOGICAL_ACCESS_DENIED = 400;
export const AUTH_INVALID_MESSAGE = 'Вы не авторизованы, войдите в приложение для корректной работы';
export const TINKOFF_SUCCESS_PAGE = '/order-success';